import {Constants} from "./Constants";

export var EnvironmentUtility = {
    inTestingEnvironment: function () {
        let environment = document.querySelector(".rails-environment").innerHTML;
        return (
            environment === Constants.railsEnvironments.development ||
            environment === Constants.railsEnvironments.e2e_test
        )
    },
};
